import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Factory } from 'app/app.factory';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface PendingAcceptance {
    type: 'PRIVACY_POLICY' | 'TERMS';
    version: string;
    hash: string;
    url: string;
}

export interface PendingAcceptancesResponse {
    success: boolean;
    data: { pending: PendingAcceptance[] };
}

export interface AcceptPayload {
    privacy_policy_version?: string;
    terms_version?: string;
    channel?: 'WEB' | 'MOBILE';
}

@Injectable({ providedIn: 'root' })
export class PrivacyService {
    private _http = inject(HttpClient);
    private _factory = inject(Factory);

    /** Returns list of policies the user must accept. [] if all up to date. */
    getPendingAcceptances(): Observable<PendingAcceptance[]> {
        return this._http
            .get<PendingAcceptancesResponse>(`${this._factory.coruscant}/privacy/pending-acceptances`)
            .pipe(
                map((r) => r?.data?.pending ?? []),
                catchError(() => of([])),
            );
    }

    /** Persist user acceptance of both documents. */
    accept(payload: AcceptPayload): Observable<boolean> {
        return this._http
            .post<{ success: boolean }>(`${this._factory.coruscant}/privacy/accept`, {
                channel: 'WEB',
                ...payload,
            })
            .pipe(
                map((r) => r?.success === true),
                catchError(() => of(false)),
            );
    }

    /** Fetch legal document markdown (public endpoint). */
    getLegalDocument(url: string): Observable<string> {
        return this._http
            .get(`${this._factory.coruscant}${url}`, { responseType: 'text' })
            .pipe(catchError(() => of('# Documento no disponible')));
    }
}
